import React from "react";

const AssetDetailModal = ({ isOpen, onClose, asset, formatDate }) => {
  if (!isOpen || !asset) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="detail-modal-header">
          <h3>Asset Details</h3>
          <button className="close-button-x" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="detail-modal-content">
          <div className="detail-row">
            <span className="detail-label">Iridis ID:</span>
            <span className="detail-value">{asset.iridis_id}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Asset Name:</span>
            <span className="detail-value">{asset.asset_name}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Staff Name:</span>
            <span className="detail-value">{asset.staff_name}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Role:</span>
            <span className="detail-value">{asset.role}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Staff ID:</span>
            <span className="detail-value">{asset.staff_id}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Phone:</span>
            <span className="detail-value">{asset.phone}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Email:</span>
            <span className="detail-value">{asset.email}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Reason for Acquisition:</span>
            <span className="detail-value">{asset.reason_for_acquisition}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Acquisition Date:</span>
            <span className="detail-value">
              {formatDate(asset.acquisition_date)}
            </span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Approving Authority:</span>
            <span className="detail-value">{asset.approving_authority}</span>
          </div>

          <div className="detail-row">
            <span className="detail-label">Expected Return Date:</span>
            <span className="detail-value">
              {formatDate(asset.expected_return_date)}
            </span>
          </div>

          {asset.return_date && (
            <div className="detail-row">
              <span className="detail-label">Return Date:</span>
              <span className="detail-value">
                {formatDate(asset.return_date)}
              </span>
            </div>
          )}

          <div className="detail-row">
            <span className="detail-label">Initial Condition:</span>
            <span className="detail-value">{asset.initial_condition}</span>
          </div>

          {asset.return_condition && (
            <div className="detail-row">
              <span className="detail-label">Return Condition:</span>
              <span className="detail-value">{asset.return_condition}</span>
            </div>
          )}

          <div className="detail-row">
            <span className="detail-label">Status:</span>
            <span
              className={`detail-status ${
                asset.return_date ? "returned" : "not-returned"
              }`}
            >
              {asset.return_date ? "Returned" : "Not Returned"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetDetailModal;
